<template lang="pug">
.stock-detail(v-if="info")
  .overview
    .title
      span {{ info.detail.name || "--" }}
      span {{ info.detail.id || "--" }}
    .section
      .des {{ desData }}
      .history-event.light(@click="jumpEventList") 查看历史事件{{info.count}}次
        span >
  .business-time.card
    .title 最佳交易时间窗分析
    .tip 基于历史事件股，采用量化模型计算生成
    .content
      TimeBar(:bar-data="barInfo.barData")
  .buy-stock.card
    .title 若事件发生日买入该股
    .content
      .table(v-for="(item,i) in avgChgList" :key="i")
        span {{ item[0] }}
        span(:class="item[2] | probabilityColorFormat") {{ item[2] | validRatio }}
        span(:class="item[1] | valueColorFormat") {{ item[1] | validRatio }}
  .reference-trading.card(style="margin:0")
    .title 参考买卖价
    .tip 数据来源：市场公开的研报分析，该数据仅供参考
    .content
      stock-charts(:chart-data="chartData")
</template>

<script>
import { parseValidRatio, valueColorFormat, probabilityColorFormat, isNumber } from '@utils/values'
import { dateToDateStr, dateToDateObj } from '@utils/time_helper'
import Requests from '@utils/requests'
import TimeBar from '@components/time_bar'
import StockCharts from '@components/stock_charts'

export default {
  name: 'StockDetail',
  components: {
    TimeBar,
    StockCharts
  },
  props: {
    pathName: String
  },
  filters: {
    validRatio(v, suffix = '%') {
      if (!isNumber(v)) {
        return v
      }
      return `${v.toFixed(2)}${suffix}`
    },
    valueColorFormat,
    probabilityColorFormat
  },
  data() {
    return {
      barInfo: {},
      avgChgList: [],
      desData: [],
      chartData: null
    }
  },
  computed: {
    info() {
      return this.$store.state.stockDetail
    }
  },
  mounted() {
    this.$store.dispatch('getStockDetail').then(state => {
      if (!state) {
        return false
      }
      this.barInfoFormat(state)
      this.buyStockFormat(state.detail.avg_chg_list)
      this.referenceTrading(state.detail.id)
    })
  },
  methods: {
    // 跳转历史事件页面
    jumpEventList() {
      this.$router.push({
        name: this.pathName
      })
    },
    // 最佳交易时间窗分析
    barInfoFormat(info) {
      const startNum = info.window_start
      const endNum = info.window_end
      const nowDate = info.detail.now_date
      let barData = [{ value: info.detail.now_date, label: '事件发生日', id: 'nowDate' }]
      if (startNum !== 0) {
        barData.push({
          value: info.detail.start_date,
          label: `${startNum > 0 ? '后' : '前'}${Math.abs(startNum)}个交易日`,
          id: 'startDate'
        })
      }
      if (endNum !== 0) {
        barData.push({
          value: info.detail.end_date,
          label: `${endNum < 0 ? '前' : '后'}${Math.abs(endNum)}个交易日`,
          id: 'endDate'
        })
      }
      barData.sort(function(a, b) { return a.value - b.value })
      barData = barData.map(item => {
        return {
          ...item,
          value: dateToDateStr(item.value, '.').substring(5)
        }
      })
      this.barInfo = {
        startNum,
        endNum,
        nowDate,
        barData
      }
      // 文字描述
      const desData = []
      desData.push(
        `个股在相关该事件中最佳交易时间窗区间是事件发生${startNum > 0 ? '后' : '前'}${Math.abs(startNum)}个交易日到事件发生${endNum < 0 ? '前' : '后'}${Math.abs(endNum)}个交易日，`,
        `上涨概率为${parseValidRatio(info.detail.victory)}，平均涨幅为${parseValidRatio(info.detail.chg)}。`,
        (info.detail.target_price.min || info.detail.target_price.max) && '参考目标价',
        info.detail.target_price.min && `最低为${info.detail.target_price.min}`,
        (info.detail.target_price.min && info.detail.target_price.max) && '，',
        info.detail.target_price.max && `最高为${info.detail.target_price.max}`,
        (info.detail.target_price.min || info.detail.target_price.max) && '。'
      )
      this.desData = desData.join('')
    },
    // 事件发生日买入该股
    buyStockFormat(list) {
      this.avgChgList = list.map((item, i) => {
        if (i === 0) {
          item[0] = ' '
          item[1] = '涨幅'
          item[2] = '概率'
        } else {
          item[0] = dateToDateStr(item[0], '.').substring(5, 10)
        }
        return item
      })
      console.log(this.avgChgList)
    },
    // 参考买卖价
    referenceTrading(id) {
      return new Promise(resolve => {
        Requests({
          url: '/shudan/get_stock_recent_kline_for_api',
          method: 'post',
          params: { stock_id: id }
        }).then(({ data }) => {
          const kline = data.data.kline.split('\n').map(item => {
            const [x, open, high, low, close, chg, volumn, volumeBusiness, turnoverRates] = item.split(',')
            return {
              x: dateToDateObj(x).getTime(), // 日期
              open: open / 10000, // 开盘价
              high: high / 10000, // 最高价
              low: low / 10000, // 最低价
              close: close / 10000, // 收盘价
              chg: chg / 100, // 涨幅
              volume: Number(volumn), // 成交量
              volumeBusiness: Number(volumeBusiness), // 成交额
              turnoverRate: turnoverRates / 10000 // 换手率
            }
          })
          kline.sort(function(a, b) { return a.x - b.x })
          this.chartData = {
            name: this.info.detail.name,
            maxData: kline.sort(function(a, b) { return b.high - a.high })[0].high,
            minData: kline.sort(function(a, b) { return a.low - b.low })[0].low,
            data: kline,
            targetPrice: data.data.target_price
          }
        })
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.stock-detail
  min-height 100vh
  background-color #fff
  .card
    padding 1rem
    margin 1rem 0
    .title
      font-size 1.07rem
      font-weight 600
    .tip
      color $light-text-color
      font-size .86rem
      padding-top .71rem
    .content
      padding-top 1.14rem
  .overview
    padding 1rem 1rem 0 1rem
    background-image linear-gradient($theme-color,#fff)
    .title
      display flex
      flex-direction column
      align-items center
      color #fff
      span
        &:first-child
          font-size 1.29rem
          font-weight 600
        &:last-child
          font-size .86rem
          line-height 1.14rem
    .section
      box-sizing border-box
      box-shadow #ccc 0 0 1.07rem
      // height 10.71rem
      margin 1rem 0 0 0
      .des
        line-height 1.71rem
      .history-event
        margin-top 1rem
        font-size .86rem
        display flex
        align-items center
        width 9.29rem
        >span
          font-size 1.14rem
          padding-left 2px
  .buy-stock
    .content
      display flex
      .table
        display flex
        flex-direction column
        width 100%
        &:nth-child(1)
          border-left 1px solid $border-color
          background $box-bg-color
          text-align center
          >span
            color $normal-text-color
        >span
          height 2.29rem
          line-height 2.29rem
          text-align center
          border-bottom 1px solid $border-color
          border-right 1px solid $border-color
          &:nth-child(1)
            border-top 1px solid $border-color
            background $box-bg-color
</style>
